module.exports = __webpack_public_path__ + "static/media/ipod.989c9beb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/illus/ipod.svg
// module id = 151
// module chunks = 0